// React
import { useEffect } from 'react';

// Src
import { fetchMetaJsonRequest } from '@/application/utils/versionUtils';
import { logoutRequestAction } from '@/domain/authentication/reducers/authenticationReducer';
import { updateVersionAction } from '@/infrastructure/redux/clientState/versionReducer';
import { useAppDispatch } from '@/infrastructure/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/infrastructure/redux/hooks/useAppSelector';

export function useGetVersion() {
    // Hooks
    const meta = useAppSelector((selector) => selector.versionReducer);
    const dispatch = useAppDispatch();

    // Effects
    useEffect(() => {
        fetchMetaJsonRequest().then(async (request) => {
            const body = await request.json();
            if (meta.build && (body.build !== meta.build || body.version !== meta.version)) {
                localStorage.clear();
                dispatch(logoutRequestAction());
            }
            if (body) {
                dispatch(
                    updateVersionAction({
                        version: body.version,
                        build: body.build,
                    })
                );
            }
        });
    }, []);

    return { meta };
}
